/**
 * VueでハンドリングするためのDummy用DataTypes
 */
export const dataTypes = {
  STRING: (...args) => t('STRING', ...args),
  TEXT: (...args) => t('TEXT', ...args),
  CITEXT: (...args) => t('CITEXT', ...args),
  INTEGER: (...args) => t('INTEGER', ...args),
  BIGINT: (...args) => t('BIGINT', ...args),
  FLOAT: (...args) => t('FLOAT', ...args),
  REAL: (...args) => t('REAL', ...args),
  DOUBLE: (...args) => t('DOUBLE', ...args),
  DECIMAL: (...args) => t('DECIMAL', ...args),
  DATE: (...args) => t('DATE', ...args),
  DATEONLY: (...args) => t('DATEONLY', ...args),
  BOOLEAN: (...args) => t('BOOLEAN', ...args),
  ENUM: (...args) => t('ENUM', ...args),
  ARRAY: (...args) => t('ARRAY', ...args),
  JSON: (...args) => t('JSON', ...args),
  JSONB: (...args) => t('JSONB', ...args),
  BLOB: (...args) => t('BLOB', ...args),
  UUID: (...args) => t('UUID', ...args),
  CIDR: (...args) => t('CIDR', ...args),
  INET: (...args) => t('INET', ...args),
  MACADDR: (...args) => t('MACADDR', ...args),
  RANGE: (...args) => t('RANGE', ...args),
  GEOMETRY: (...args) => t('GEOMETRY', ...args),
}

const t = (typeName, ...args) => {
  return `${typeName}${args.length ? `(${args.join(',')})` : ''}`
}

export default dataTypes
